import { SyncRule as g, RuleType as f } from "./Rule.js";
const p = (e, { min: s, max: o }) => s !== void 0 && o !== void 0 ? s > o ? "min" : e >= s && e <= o ? !0 : e > o ? "max" : e < s ? "min" : !0 : s !== void 0 && o === void 0 ? e >= s ? !0 : "min" : s === void 0 && o !== void 0 ? e <= o ? !0 : "max" : !0;
class C extends g {
  validate(s) {
    const { min: o, max: l } = this.config, a = s.length, t = p(a, { min: o, max: l });
    return {
      isValid: t === !0,
      failingBoundary: t === !0 ? void 0 : t,
      length: a,
      ruleType: f.length,
      ...this.config
    };
  }
}
class P extends g {
  validate(s) {
    const { blocklist: o, substringMatch: l, ...a } = this.config, t = o.map((i) => i.toLowerCase()), u = s.toLowerCase(), n = l ? t.some((i) => u.includes(i)) : t.includes(u), c = l && n ? t.filter((i) => u.includes(i)) : void 0, h = (({ blocklist: i, ...r }) => r)(this.config);
    return {
      isValid: !n,
      blockedSubstrings: c,
      ruleType: f.blocklist,
      ...h,
      ...a
    };
  }
}
const v = {
  lowercase: /[a-zäöüß]/g,
  uppercase: /[A-ZÄÖÜẞ]/g,
  numbers: /\d/g,
  special: /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g,
  nonAscii: /[^ -~]/g
};
class m extends g {
  validate(s) {
    const { max: o, charPools: l, ...a } = this.config, t = this.config.min === void 0 && o === void 0 ? 1 : this.config.min, u = [];
    let n = 0;
    for (const i of l) {
      const r = v[i], d = s.match(r)?.length ?? 0;
      u.push({
        charPool: i,
        occurrences: d
      }), n += d;
    }
    const c = p(n, { min: t, max: o }), h = (({ charPools: i, ...r }) => r)(
      this.config
    );
    return {
      isValid: c === !0,
      failingBoundary: c === !0 ? void 0 : c,
      ruleType: f.charPool,
      charPools: u,
      totalOccurrences: n,
      ...h,
      min: t,
      ...a
    };
  }
}
class b extends g {
  validate(s) {
    const { max: o, chars: l, ...a } = this.config, t = this.config.min === void 0 && o === void 0 ? 1 : this.config.min, u = l.split(""), n = [];
    let c = 0;
    for (const r of u) {
      const d = s.split(r).length - 1;
      n.push({ char: r, occurrences: d }), c += d;
    }
    const h = p(c, { min: t, max: o }), i = (({ chars: r, ...d }) => d)(this.config);
    return {
      isValid: h === !0,
      failingBoundary: h === !0 ? void 0 : h,
      chars: n,
      totalOccurrences: c,
      ruleType: f.char,
      ...i,
      min: t,
      ...a
    };
  }
}
export {
  P as B,
  m as C,
  C as L,
  b as a,
  p as v
};
